export default __webpack_public_path__ + "static/media/easy-return.f419b887.png";